module.exports = require("@swa-ui/core/src/Focusable/Focusable.module.scss");